export default __webpack_public_path__ + "fab50d3.png";